/* eslint-disable no-param-reassign */
import { useLayoutEffect } from 'react';

export default function useLockBodyScrollVertical(isActive) {
    useLayoutEffect(() => {
        if (isActive) {
            const isIOS14OrAbove =
                /(iphone|ipad)/i.test(navigator?.userAgent) &&
                /OS [1-9][4-9]|[2-9][0-9]/i.test(navigator?.userAgent);
            if (!isIOS14OrAbove) {
                const originalStyle = window.getComputedStyle(document.body)
                    .overflow;
                document.body.style.overflowY = 'hidden';
                document.body.style.touchAction = 'none';
                return () => {
                    document.body.style.overflowY = originalStyle;
                    document.body.style.touchAction = 'auto';
                };
            }
        }
        return undefined;
    }, [isActive]);
}
